"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Item_1 = __importDefault(require("./Item/Item"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var Dropdown_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Dropdown"));
var react_1 = require("react");
var localization_1 = require("@scuf/localization");
var collapsedMaxNumber = 6;
/**
 * The page header can contain the child AppLauncher component, which lets you show a list of items with icons or images that you can click and assign an action to.
This list of items will appear when you hover over the AppLauncher icon (the 9 little squares that make one big square).
There are 3 different view states for showing the available items, and it is dependent on the number of child items.
If there are 6 or fewer items, a basic container with all of the items will show. If there are 6-8 items, there will be a "See more" option with the additional items.
If there are more than 8 items, there will also be a "See more option", with the added ability to scroll to see additional items.
 * @child ./Item/Item.tsx
 */
var AppLauncher = /** @class */ (function (_super) {
    __extends(AppLauncher, _super);
    function AppLauncher(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            seeMore: false
        };
        return _this;
    }
    AppLauncher.prototype.render = function () {
        var _this = this;
        var rest = __rest(this.props, []);
        return (React.createElement(Dropdown_1.default, __assign({}, rest, { className: "app-launcher", item: true, simple: true, direction: "right", icon: "", trigger: React.createElement("span", { className: "trigger-container" },
                React.createElement(Icon_1.default, { name: "app-launcher", root: "common", className: "trigger-icon" }),
                React.createElement("span", { className: "responsive-trigger-label" }, "Applications")), closeOnChange: false, openOnFocus: false, onBlur: function () { return _this.setState({ seeMore: false }); } }),
            React.createElement(Dropdown_1.default.Menu, { className: "app-launcher-menu" },
                this.renderItems(),
                this.renderFooter())));
    };
    AppLauncher.prototype.renderItems = function () {
        var seeMore = this.state.seeMore;
        return (React.Children.toArray(this.props.children).map(function (child, index) {
            return (React.createElement(React.Fragment, { key: index },
                seeMore &&
                    child,
                !seeMore && index < collapsedMaxNumber &&
                    child));
        }));
    };
    AppLauncher.prototype.renderFooter = function () {
        var _this = this;
        var children = this.props.children;
        var seeMore = this.state.seeMore;
        if (children && React.Children.count(children) > collapsedMaxNumber) {
            return (React.createElement(localization_1.TranslationConsumer, null, function (t, lng) { return (React.createElement("div", { className: "menu-footer", onClick: function (e) {
                    e.stopPropagation();
                    _this.setState({ seeMore: !seeMore });
                } },
                React.createElement("span", null, seeMore ? t('See less') : t('See more')),
                React.createElement(Icon_1.default, { root: "common", name: seeMore ? 'caret-up' : 'caret-down', exactSize: 16 }))); }));
        }
        else {
            return null;
        }
    };
    AppLauncher.Item = Item_1.default;
    return AppLauncher;
}(react_1.Component));
exports.default = AppLauncher;
